import { injectable, injectFromBase } from 'inversify'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import DeletedEntity from '@/data/models/DeletedEntity'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'

@injectable()
@injectFromBase()
@RepoSettings<Endpoint>({
  model: DeletedEntity,
})
export default class DeletedEntityRepository extends OrmApiRepository<DeletedEntity> {}
